import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.hexalogixautomation.com';

// SEO Component for managing meta tags
export const SEOHead = ({ 
  title = "Hexalogix Automation | Industrial Automation & Control Panels UAE",
  description = "Industrial automation, control panel manufacturing, PLC programming & marine automation. Serving UAE, Africa & the Middle East since 2019.",
  keywords = "industrial automation, control panel manufacturing, PLC programming, marine automation, BMS systems, UAE automation, Africa automation, Siemens PLC, Schneider Electric, control panels UAE",
  ogImage = "https://www.hexalogixautomation.com/hero-desktop.webp",
  ogType = "website",
  canonical,
  robots = "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
  schemas = []
}) => {
  const location = useLocation();
  const url = `${SITE_URL}${location.pathname}`;
  const canonicalUrl = canonical || url;

  useEffect(() => {
    // Update title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);

    // Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:type', ogType, true);
    updateMetaTag('og:url', canonicalUrl, true);
    updateMetaTag('og:image', ogImage, true);
    updateMetaTag('og:site_name', 'Hexalogix Automation', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', ogImage);
    updateMetaTag('robots', robots);
    updateMetaTag('googlebot', robots);

    // Update canonical link
    let linkElement = document.querySelector('link[rel="canonical"]');
    if (!linkElement) {
      linkElement = document.createElement('link');
      linkElement.setAttribute('rel', 'canonical');
      document.head.appendChild(linkElement);
    }
    linkElement.setAttribute('href', canonicalUrl);

    document.querySelectorAll('script[data-seo-schema="dynamic"]').forEach((node) => node.remove());

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.seoSchema = 'dynamic';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-seo-schema="dynamic"]').forEach((node) => node.remove());
    };
  }, [title, description, keywords, ogImage, ogType, canonicalUrl, robots, schemas]);

  return null;
};
